<template>
    <div>
      <v-row
          style="margin-bottom: 85px;"
          class="pa-0 ma-0"
      >
          <v-col cols="12" class="pa-0 ma-0">
              <component :key="refreshed" :is="pageName" v-if="pageName" v-on:edit="editTranslation" v-on:addToGallery="addToGallery" v-on:removeFromGallery="removeFromGallery" :serviceName="service" v-on:editImage="editAsset" :editable="true" />
              <!--
              <homepage v-if="showAccueil" v-on:edit="editTranslation"></homepage>
              <about v-if="showApropos"  v-on:edit="editTranslation"></about>
              <contact v-if="showContact" v-on:edit="editTranslation"></contact>
              <customer-login v-if="showLogin" v-on:edit="editTranslation"></customer-login>
              -->
          </v-col>
      </v-row>
      <v-row class="pa-0 ma-0">
        <v-col md="12" style="position:fixed; bottom:0;" class="pa-0 ma-0">
          <v-toolbar color="primary" dark>
            <v-btn :to="{name: 'dashboard'}" exact icon><v-icon>mdi-arrow-left</v-icon></v-btn>

            <v-toolbar-title>Ceci est une prévisualisation de la page d'accueil du site web.</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-select
              :items="['Accueil', 'A Propos', 'Contact', 'FAQ', 'Gallerie', 'Politique de confidentialité', 'Services', 'Service (unique)', 'Demande de devis'/*'Connexion Client'*/]"
              hide-details
              v-model="page"
              label="Page à éditer"
            ></v-select>
            <v-select
              :items="[{ text: $vuetify.lang.t('$vuetify.menu.ship_freight'), value: 'ship-freight' }, { text: $vuetify.lang.t('$vuetify.menu.sea_freight'), value: 'sea-freight' }, { text: $vuetify.lang.t('$vuetify.menu.air_freight'), value: 'air-freight' }, { text: $vuetify.lang.t('$vuetify.menu.road_freight'), value: 'road-freight' }]"
              v-if="page == 'Service (unique)'"
              hide-details
              @change="refreshed++"
              v-model="service"
              label="Service"
            ></v-select>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-dialog v-model="editText" max-width="450px">
        <v-card>
          <v-card-title class="headline">
            Editer " <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">{{editTmp.key}}</span> "
          </v-card-title>

          <v-card-text>
            <div>
              <v-btn-toggle>
                <v-btn @click="textarea = false">
                  une seule ligne
                </v-btn>

                <v-btn  @click="textarea = true">
                  plusieurs lignes
                </v-btn>
              </v-btn-toggle>
            </div>
            <template v-if="textarea">
              <v-textarea
                label="Français"
                :value="editTmp.fr"
                v-model="editTmp.fr"
              ></v-textarea>
              <v-textarea
                label="English"
                :value="editTmp.en"
                v-model="editTmp.en"
              ></v-textarea>
            </template>
            <template v-else>
              <v-text-field
                label="Français"
                :value="editTmp.fr"
                v-model="editTmp.fr"
              ></v-text-field>
              <v-text-field
                label="English"
                :value="editTmp.en"
                v-model="editTmp.en"
              ></v-text-field>
            </template>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary darken-1"
              text
              @click="editText = false"
            >
              Annuler
            </v-btn>

            <v-btn
              color="primary"
              @click="editData"
            >
              Editer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editImage" max-width="450px">
        <v-card>
          <v-card-title class="headline">
            Editer une image
          </v-card-title>

          <v-card-text>
            <div>
              {{ editImageTmp }}
              <v-file-input
                truncate-length="15"
                v-model="file"
                accept="image/*"
              ></v-file-input>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary darken-1"
              text
              @click="editImage = false"
            >
              Annuler
            </v-btn>

            <v-btn
              color="primary"
              @click="setImage"
            >
              Editer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <v-dialog v-model="addImage" max-width="450px">
        <v-card>
          <v-card-title class="headline">
            Ajouter une image au gallerie
          </v-card-title>

          <v-card-text>
            <div>
              <v-file-input
                truncate-length="15"
                v-model="file"
                accept="image/*"
              ></v-file-input>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary darken-1"
              text
              @click="editImage = false"
            >
              Annuler
            </v-btn>

            <v-btn
              color="primary"
              @click="setGallery"
            >
              Ajouter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
    
<script>
import headerSidebar from '../commons/header_sidebar.component' 
import homepage from '../../website/default'
import about from '../../website/about'
import faq from '../../website/faq'
import gallery from '../../website/gallery'
import contact from '../../website/contact'
import singleService from '../../website/services/single'
import services from '../../website/services/listing'
import privacy from '../../website/services/listing'
import customerLogin from '../../website/customer/login'
import requestQuotation from '../../website/request-quotation'
import { i18n, loadLanguageAsync } from '../../../plugins/i18n'
    export default {
        name: 'manage-website',
        data: () => ({
          page: 'Accueil',
          pageName: 'homepage',
          editImage: false,
          editText: false,
          editTmp: {},
          editImageTmp: {},
          pageToEdit:'',
          textarea: false,
          file: null,
          addImage: false,
          refreshed: 0,
          service: 'air-freight'
        }),
        components: { headerSidebar, homepage, faq, gallery, about, contact, customerLogin, singleService, services, privacy, requestQuotation },
        watch: {
          page(){
            console.log(this.page)
            if(this.page === 'Accueil'){
              this.pageName = 'homepage'
            }else if(this.page === 'A Propos'){
              
              this.pageName = 'about'
            }else if(this.page === 'Contact'){
              
              this.pageName = 'contact'
            }else if(this.page === 'Services'){
              
              this.pageName = 'services'
            }else if(this.page === 'Service (unique)'){
              
              this.pageName = 'singleService'
            }else if(this.page === 'Demande de devis'){
              
              this.pageName = 'requestQuotation'
            }else if(this.page === 'FAQ'){
              
              this.pageName = 'faq'
            }else if(this.page === 'Gallerie'){
              
              this.pageName = 'gallery'
              /*this.showLogin = true
              this.showAccueil = false
              this.showApropos = false
              this.showContact = false*/
            }
          }
        },
        methods: {
          async editTranslation(data){
            const dv = (obj, path) => 
                  path
                    .replace(/\[|\]\.?/g, '.')
                    .split('.')
                    .filter(s => s)
                    .reduce((acc, val) => acc && acc[val], obj);
                    
            await this.axios
                .get("../website/get/lang/fr")
                .then(res => (this.editTmp.fr = dv(res.data.$vuetify, data.name)))
            await this.axios
                .get("../website/get/lang/en")
                .then(res => {
                  this.editTmp.en = dv(res.data.$vuetify, data.name)
                })
            let self = this
            this.editTmp.key = data.name
            this.pageToEdit = data.page
            this.editText = true
          },
          addToGallery() {
            this.addImage = true
          },
          setImage(){
            let formData = new FormData()
            formData.append('image', this.file)
            formData.append('key', this.editImageTmp.name)
            //this.agentTmp.picture_url = this.user_picture
            this.axios.post('../website/set/asset', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then((res) => {
                if(res.data === 'error'){
                }else{
                  
                }
                console.log(res)
                
              }).catch(e => {
                console.log(e)
              })
          },
          removeFromGallery(data) {
            let key = data.key
            this.axios
                .post("../website/remove/gallery", { key })
                .then(res => {
                  if(!res.error){
                    this.refreshed = this.refreshed+1
                  }
                })
          },
          setGallery(){
            let formData = new FormData()
            formData.append('image', this.file)
            //formData.append('key', this.editImageTmp.name)
            //this.agentTmp.picture_url = this.user_picture
            this.axios.post('../website/set/gallery', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then((res) => {
                if(res.data === 'error'){

                }else{
                  this.file = null
                  this.addImage = false
                  this.editImageTmp = {}
                  this.refreshed = this.refreshed+1
                }
                console.log(res)
                
              }).catch(e => {
                console.log(e)
              })
          },
          async editAsset(data) {
            await this.axios
                .get("../website/get/assets")
                .then(res => console.log(res))

            this.editImage = true
            this.editImageTmp = data
            console.log(data)
          },
          editData(){
            let data = {data: this.editTmp}
            console.log(data)
            this.axios
                .post("../website/set/lang", data)
                .then(res => {
                  if(!res.error){
                    let tmp = i18n.locale
                    loadLanguageAsync(i18n.locale).then(() => {})
                    this.editText = false
                  }
                })
          }
        }
    } 
</script>


<style lang="scss" scoped>
 .privilege-checkbox >>> .v-label {
     font-size:12px;
 }
 .v-data-table >>> .text-start{
    height:85px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/website/settings.vue